import { render } from "./AdministratorListComponent.vue?vue&type=template&id=6c536e00&scoped=true"
import script from "./AdministratorListComponent.vue?vue&type=script&lang=js"
export * from "./AdministratorListComponent.vue?vue&type=script&lang=js"

import "./AdministratorListComponent.vue?vue&type=style&index=0&id=6c536e00&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c536e00"],['__file',"resources/js/components/admin/administrators/AdministratorListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c536e00"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c536e00', __exports__)) {
    api.reload('6c536e00', __exports__)
  }
  
  module.hot.accept("./AdministratorListComponent.vue?vue&type=template&id=6c536e00&scoped=true", () => {
    api.rerender('6c536e00', render)
  })

}


export default __exports__